import React, { useState } from "react";
import PropTypes from "prop-types";
import { ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText } from "reactstrap";
import TooltipImage from "../../ui/tooltip-image";
import Loader from "../../ui/loader";

import {
  toHibridAccountingkeyFormat,
  toHibridSocietyFormat,
  toHibridDivisionFormat,
  toHibridClaimAreaFormat,
  toFormattedNumber,
  toFormattedDate
} from "../../../utils/format";
import { calculateCurency } from "../reconciliation-detail";

const ExpandedRow = ({ list, loading, error, columnsLength }) => {
  const [openedRows, setOpenedRows] = useState([]);

  if (loading) return <Loader />;
  if (error) return <div />;

  return (
    <>
      {list.map((element, index) => {
        const isOpened = openedRows.includes(index);
        const {
          date,
          expiringDate,
          society,
          division,
          recArea,
          comments,
          document: documentParam,
          customer,
          accountingKey,
          amount,
          currency,
          ceco,
          customerName,
          amountForeign,
          customerId
        } = element;
        const currencyText = currency ? calculateCurency(currency) : "€";
        const foreignCurrency = currencyText !== "€";
        return (
          <table
            className={`expanded-row ${isOpened ? "opened-expanded-row" : "closed-expanded-row"}`}
          >
            <tr
              className="header"
              onClick={() => {
                const newRows = openedRows.slice(0, openedRows.length);
                if (isOpened) {
                  newRows.splice(newRows.indexOf(index), 1);
                } else {
                  newRows.push(index);
                }
                setOpenedRows(newRows);
              }}
            >
              <td colSpan={columnsLength - 4} className="colSpan-text">
                <TooltipImage
                  iconClassName={isOpened ? "icono-arrow-top-basic" : "icono-arrow-down-basic"}
                  tooltipText={isOpened ? "Colapsar detalle" : "Expandir detalle"}
                />
                {accountingKey && (
                  <span>
                    {`${toHibridAccountingkeyFormat(accountingKey)}${
                      documentParam ? ` - ${documentParam}` : ""
                    }`}
                  </span>
                )}
                {customer && <span className="texto-col-divisor">|</span>}
                {customer && (
                  <span>
                    {`Cliente - ${customerName || customer}`}
                    {customerId ? ` - ${customerId}` : ""}
                  </span>
                )}
                {ceco && <span>{`CECO - ${ceco}`}</span>}
              </td>
              <td>
                <div className="text-right mr-3">
                  {`${toFormattedNumber(
                    foreignCurrency && amountForeign ? amountForeign : amount
                  )}${currencyText}`}
                </div>
              </td>
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
            </tr>
            {isOpened && (
              <tr className="body">
                <td colSpan={columnsLength + 4}>
                  <div className="divisor" />
                  <ListGroup>
                    {date && (
                      <ListGroupItem>
                        <ListGroupItemHeading>Fecha</ListGroupItemHeading>
                        <ListGroupItemText>{toFormattedDate(date)}</ListGroupItemText>
                      </ListGroupItem>
                    )}
                    {expiringDate && (
                      <ListGroupItem>
                        <ListGroupItemHeading>Fecha Vto</ListGroupItemHeading>
                        <ListGroupItemText>{toFormattedDate(expiringDate)}</ListGroupItemText>
                      </ListGroupItem>
                    )}
                    {society && (
                      <ListGroupItem>
                        <ListGroupItemHeading>Sociedad</ListGroupItemHeading>
                        <ListGroupItemText>{toHibridSocietyFormat(society)}</ListGroupItemText>
                      </ListGroupItem>
                    )}
                    {division && (
                      <ListGroupItem>
                        <ListGroupItemHeading>División</ListGroupItemHeading>
                        <ListGroupItemText>{toHibridDivisionFormat(division)}</ListGroupItemText>
                      </ListGroupItem>
                    )}
                    {recArea && (
                      <ListGroupItem>
                        <ListGroupItemHeading>Área Reclamación</ListGroupItemHeading>
                        <ListGroupItemText>
                          {toHibridClaimAreaFormat(society, recArea)}
                        </ListGroupItemText>
                      </ListGroupItem>
                    )}
                    {comments && (
                      <ListGroupItem>
                        <ListGroupItemHeading>Observaciones</ListGroupItemHeading>
                        <ListGroupItemText>{comments}</ListGroupItemText>
                      </ListGroupItem>
                    )}
                  </ListGroup>
                </td>
              </tr>
            )}
          </table>
        );
      })}
    </>
  );
};

ExpandedRow.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      expiringDate: PropTypes.string,
      society: PropTypes.string,
      division: PropTypes.string,
      recArea: PropTypes.string,
      comments: PropTypes.string,
      document: PropTypes.string,
      customer: PropTypes.string,
      accountingKey: PropTypes.string,
      majorAccount: PropTypes.string,
      ceco: PropTypes.string
    })
  ),
  loading: PropTypes.bool,
  error: PropTypes.bool,
  columnsLength: PropTypes.number
};

ExpandedRow.defaultProps = {
  list: [],
  loading: false,
  error: false,
  columnsLength: 1
};

export default ExpandedRow;
